import React, { useState, useEffect } from 'react';
import { Trophy } from 'lucide-react';
import { loadTipsters } from '../services/firebase';
import { ClipLoader } from 'react-spinners';

const TipstersPage = ({ user }) => {
  const [tipsters, setTipsters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTipsters = async () => {
      try {
        const loadedTipsters = await loadTipsters();
        setTipsters(loadedTipsters);
      } catch (error) {
        console.error("Error loading tipsters:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTipsters();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen py-20">
        <div className="text-center">
          <ClipLoader color="#10B981" size={50} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">Tipsters</h1>
        {tipsters.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg">
            <Trophy size={48} className="mx-auto text-gray-400 mb-4" />
            <p className="text-gray-500">No tipsters have joined yet. Be the first!</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {tipsters.map((tipster) => (
              <div key={tipster.id} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-xl font-semibold">{tipster.displayName || tipster.email}</h3>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    tipster.membershipTier === 'diamond' ? 'bg-blue-100 text-blue-800' :
                    tipster.membershipTier === 'gold' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {tipster.membershipTier}
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-center mb-4">
                  <div className="bg-gray-50 rounded p-2">
                    <p className="text-xs text-gray-600">Win Rate</p>
                    <p className="font-bold text-green-600">{tipster.winRate}%</p>
                  </div>
                  <div className="bg-gray-50 rounded p-2">
                    <p className="text-xs text-gray-600">Total Tips</p>
                    <p className="font-bold">{tipster.totalBets}</p>
                  </div>
                  <div className="bg-gray-50 rounded p-2">
                    <p className="text-xs text-gray-600">W-L</p>
                    <p className="font-bold">{tipster.wins}-{tipster.losses}</p>
                  </div>
                </div>
                <button className="w-full bg-gradient-to-r from-green-400 to-blue-400 text-white py-2 rounded-full hover:opacity-90 transition">
                  View Profile
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TipstersPage;